// export const ip = "http://192.168.40.147:8086/"; //测试地址
export const ip = "https://www.sclsnk.com/api/"; //正式环境地址
export const codeURL = ip + "index/loginAdmin/getVerify"; //登录图形验证码
// export const URL = "http://192.168.40.147:8086/"; //图片地址前缀
export const URL = "https://www.sclsnk.com/sclsnk_file/"; //图片地址前缀
export const uploadURL = ip + "web/file/upload"; //上传地址
